import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { consentTypeEnumSchema, patientConsentSchema } from "@libs/db-schemas";

import { HTTPStatusCode } from "../../types";
import { errorSchema } from "../../utils/errors";

const c = initContract();

export const consentsContract = c.router({
  getPendingConsents: {
    summary:
      "Get a list of consent types that the patient has not yet positively answered or that have expired",
    method: "GET",
    path: "/consents/pending",
    responses: {
      [HTTPStatusCode.OK]: z.object({
        pendingConsents: z.array(consentTypeEnumSchema),
      }),
    },
  },
  createPatientConsent: {
    summary: "Record a patient's consent response",
    method: "POST",
    path: "/consents",
    body: z.object({
      consentType: consentTypeEnumSchema,
      isConsented: z.boolean(),
    }),
    responses: {
      [HTTPStatusCode.CREATED]: patientConsentSchema,
      [HTTPStatusCode.BAD_REQUEST]: errorSchema,
      [HTTPStatusCode.NOT_FOUND]: errorSchema,
    },
  },
});
